export enum tagModel {
  SINGULAR = 'Tag',
  PLURAL = 'Tags',
  ROUTE = '/tags',
  ICON = 'mdi-bookmark',
  ITEM_KEY = 'tag',
  ITEM_KEY_UPDATE = 'tags'
}
